import { renderElement } from "../../utils/use-render.js";
import { useControlsContext } from "./context.js";
import { forwardRef } from "react";
//#region src/ui/controls/content.tsx
/** Renders the interactive controls surface. */
const ControlsContent = forwardRef(function ControlsContent(componentProps, forwardedRef) {
	const { render, className, style, children, ...elementProps } = componentProps;
	const { state, stateAttrMap } = useControlsContext();
	return renderElement("div", {
		render,
		className,
		style
	}, {
		state,
		stateAttrMap,
		ref: [forwardedRef],
		props: [
			{ children },
			elementProps,
			{ "data-interactive": "" }
		]
	});
});
//#endregion
export { ControlsContent };

//# sourceMappingURL=content.js.map